import React, { useState } from 'react';
import { useSetAtom } from 'jotai';
import { sessionAtom } from '../../jotai/atoms/session';
const UserForm = () => {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const setSession = useSetAtom(sessionAtom);
    const handleNameChange = (e) => {
        setErrorMessage('');
        setName(e.target.value);
    };
    const handleEmailChange = (e) => {
        setErrorMessage('');
        setEmail(e.target.value);
    };
    const handleSubmit = (e) => {
        e.preventDefault();
        if (name === '') {
            setErrorMessage('Name cannot be empty');
            return;
        }
        if (name.length < 5) {
            setErrorMessage('Please provide more than 5 characters');
            return;
        }
        if (email === '') {
            setErrorMessage('Email cannot be empty');
            return;
        }
        if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,9}$/i.test(email)) {
            setErrorMessage('Please provide a valid email');
        }
        else {
            setErrorMessage('');
            setSession((session) => ({
                ...session,
                user: {
                    name,
                    email,
                },
            }));
        }
    };
    return (React.createElement("div", { className: "welcome-screen" },
        React.createElement("div", { className: "form-container" },
            React.createElement("div", { className: "welcome-banner" },
                React.createElement("h1", null, "Welcome to Gyaan Kreeda"),
                React.createElement("p", null, "Please check in to continue")),
            React.createElement("form", { onSubmit: handleSubmit },
                React.createElement("div", { className: "input-group" },
                    React.createElement("input", { type: "text", name: "fullName", placeholder: " ", defaultValue: name, onChange: handleNameChange, onFocus: () => {
                            setErrorMessage('');
                        } }),
                    React.createElement("label", null, "Full Name")),
                React.createElement("div", { className: "input-group" },
                    React.createElement("input", { type: "text", name: "email", placeholder: " ", defaultValue: email, onChange: handleEmailChange, onFocus: () => {
                            setErrorMessage('');
                        } }),
                    React.createElement("label", null, "Email")),
                React.createElement("div", { className: "form-actions" },
                    React.createElement("button", { type: "submit", className: "btn--primary check-in" }, "CHECK IN")),
                errorMessage && React.createElement("div", { className: "form-error" }, errorMessage)))));
};
export { UserForm };
